import React from "react";
import { Route, Switch, Router } from "react-router-dom";
import { connect } from "react-redux";
import Login from "./Admin/login.js";
import AdminMain from "./Admin/components/main.js";
import Modal from "react-modal";
import history from './history';

export class Main extends React.Component {

    componentDidMount() {
        Modal.setAppElement('body');
    }

    render() {
        return (
            <div
                className=""
                id="table-container"
            >
                <Router history={history}>
                    <Switch>                       
                        <Route exact path="/" component={Login} />
                        <AdminMain/>
                    </Switch>
                </Router>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);
